export const tr = {
    'banners-count': {
        one: '{count} reklam',
        some: '{count} reklam',
        many: '{count} reklam',
        none: ''
    }
};
